


export const barChartDataWeeklyRevenue = [
  {
    name: "Weekly Token ",
    data: [
      { x: new Date("2025-07-01").getTime(), y: 30 },
      { x: new Date("2025-07-02").getTime(), y: 45 },
      { x: new Date("2025-07-03").getTime(), y: 60 },
      { x: new Date("2025-07-04").getTime(), y: 25 },
      { x: new Date("2025-07-05").getTime(), y: 80 },
      { x: new Date("2025-07-06").getTime(), y: 50 },
      { x: new Date("2025-07-07").getTime(), y: 70 },
    ],
    color: "#4318FF",
  },
];

export const barChartOptionsWeeklyRevenue = {
  chart: {
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  // colors:['#ff3322','#faf']
  tooltip: {
    style: {
      fontSize: "12px",
      fontFamily: undefined,
      backgroundColor: "#000000"
    },
    theme: 'dark',
    onDatasetHover: {
      style: {
        fontSize: "12px",
        fontFamily: undefined,
      },
    },
  },
  xaxis: {
    type: 'datetime',
    tickAmount: 5,
    labels: {
      show: true,
      format: 'dd MMM',
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "400",
      },
    },
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  yaxis: {
    show: true,
    tickAmount: 4,
    max: 100,
    labels: {
        formatter: function (value) {
          return value.toFixed(0);
        }
    },
    color: "black",
  },

  grid: {
    borderColor: "rgba(163, 174, 208, 0.3)",
    show: true,
    yaxis: {
      lines: {
        show: true,
        opacity: 0.5,
      },
    },
    row: {
      opacity: 0.5,
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  fill: {
    type: "solid",
    colors: ["#5E37FF", "#6AD2FF", "#E1E9F8"],
  },
  legend: {
    show: false,
  },
  colors: ["#5E37FF", "#6AD2FF", "#E1E9F8"],
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 0,
      columnWidth: "50px",
    },
  },
};
